import React, { useCallback } from 'react';
import Editor from '../../Editor';
import type { Editor as EditorCore } from '@tiptap/core';
import { EditorProps } from '../../types';
import cn from 'classnames';
import { extConfig } from './config';

import viewerStyles from '../../../Viewer/presets/Damz/Damz.scss';
import s from './Damz.scss';

export interface Props
  extends Omit<EditorProps, 'extensionConfig' | 'presetId'> {}

const DamzEditor: React.FC<Props> = ({ onChange, ...props }) => {
  const onNewChange = useCallback(
    (editor: EditorCore, trans) => {
      onChange && onChange(editor, trans);
    },
    [onChange]
  );
  return (
    <Editor
      {...props}
      initialContent={props.initialContent}
      onChange={onNewChange}
      presetId="damz"
      className={cn(s['root'], viewerStyles['root'])}
      extensionConfig={extConfig}
      characterCountOptions={
        {
          limit: 2000,
          mode: 'textSize',
        } as any
      }
      preserveWhitespace={true}
    ></Editor>
  );
};
DamzEditor.displayName = 'DamzEditor';

export default DamzEditor;
